"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsu = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const useAsu = () => {
    return (0, react_1.useContext)(context_1.AsuContext);
};
exports.useAsu = useAsu;
//# sourceMappingURL=hook.js.map